module.exports = __webpack_public_path__ + "img/运动健康之家2.10a5cfe8.jpg";